import React from 'react';
import Link from 'gatsby-link'
import BgImage from './bgimage'
import MediaHeader from './header-media'
import SEO from '../components/seo'

const HeaderContent = (props) => {
  return (
    <div className="IntroHome">
      <SEO titleSection={props.metaTitle} metaDescription={props.metaDescription} />
      <MediaHeader image={props.bgImage}/>
      <BgImage bgImage={props.bgImag2} bgImage2={props.bgImag2}/>
      <div className="leads leads-blur">{props.lead1}</div>
      <div className="leads leads-center">
        <div>
          <h1>{props.title}</h1>
          <div className="divide-content"></div>
            <p className="headerLead">{props.headerLead}</p>
          <Link className="button"
                to="/contact/"
                style={{ color: 'white', textDecoration: 'none'}} > Contáctanos </Link>
        </div>
      </div>
      <div className="leads leads-blur">{props.lead2}</div>
    </div>
  )
}

export default HeaderContent;


// WEBPACK FOOTER //
// ./src/components/header-content.js